import { FETCH_ALL_TESTS, CREATE_TEST } from '../constants/actionTypes';

const tests = (tests = [], action) => {
  switch (action.type) {
    case CREATE_TEST:
      return [...tests, action.payload];
    case FETCH_ALL_TESTS:
      return action.payload;
    default:
      return tests;
  }
};

export default tests;
